import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Redirect({ to }: { to?: string }) {
    const navigate = useNavigate();

    useEffect(() => {
        const path = `${to}`.replace('//', '/');
        navigate(path);
    });

    return null;
}

export { Redirect };
